import './OfflineActivation.scss';
import * as React from 'react';
import * as Core from 'components/core';
import CloseModal from 'app/actionCreators/CloseModal';
import SubmitOfflineActivation from 'app/actionCreators/SubmitOfflineActivation';
import { License, LicenseSeat } from 'types/license';
type Props = {
  license: License | undefined | null;
  licenseSeat: LicenseSeat | undefined | null;
  activating: boolean;
  activationError: string | undefined | null;
};
type State = {
  machineID: string;
};
export default class OfflineActivation extends React.Component<Props, State> {
  state = {
    machineID: '',
  };
  updateMachineID = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      machineID: event.currentTarget.value,
    });
  };
  activate = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (this.props.licenseSeat == null || this.props.license == null) {
      return;
    }
    SubmitOfflineActivation({
      activationArgs: {
        MachineID: this.state.machineID,
        SeatID: this.props.licenseSeat.ID,
      },
    });
  };
  render() {
    const { activating, activationError, license, licenseSeat } = this.props;
    if (licenseSeat == null || license == null) {
      throw new Error(
        'remote activation started without specifying a license and license seat',
      );
    }
    return (
      <div className="OfflineActivation">
        <div className="OfflineActivation-heading">Remote Activation</div>

        <div className="OfflineActivation-details">
          <Core.MonospacedText>{license.Serial}</Core.MonospacedText>
          <br />
          {licenseSeat.FullDescription}
        </div>

        <Core.FormGroup label="Machine ID" errorMessage={activationError}>
          <div className="OfflineActivation-form">
            <Core.Input
              type="text"
              value={this.state.machineID}
              onChange={this.updateMachineID}
              fullWidth
            />
            <Core.Input
              disabled={activating}
              type="submit"
              value="Activate"
              onClick={this.activate}
            />
            <Core.Button color="white" onClick={CloseModal}>
              Cancel
            </Core.Button>
          </div>
        </Core.FormGroup>

        <div className="OfflineActivation-instructions">
          <p>
            To install this license seat onto a Mac without needing to log that
            Mac in to your QLab account, enter that Mac&apos;s Machine ID above
            and click &quot;Activate.&quot;
          </p>

          <p>
            Then, click &quot;Download Activation File&quot; to download an
            activation file. Copy this file to the Mac whose Machine ID you
            entered and then double-click it to install the license seat.
          </p>

          <p>
            The Machine ID can be found by opening QLab and choosing
            &quot;Manage Your Licenses...&quot; from the QLab menu. The Machine
            ID is made of a mixture of numbers and letters in the format{' '}
            <Core.MonospacedText>xxxxx-xxx-xxxxx</Core.MonospacedText>.
          </p>

          <p>
            Click{' '}
            <Core.Link
              newWindow
              to="/docs/v4/general/licenses/#offline-activation"
            >
              here
            </Core.Link>{' '}
            for more information on remote activation.
          </p>
        </div>
      </div>
    );
  }
}
